const ITEMS = [
  "Foraje puțuri București · Ilfov",
  "Tubulatură PVC albastră cu filet",
  "Adâncimi 10–150 m",
  "Denisipări",
  "Ofertă pe loc",
  "Apă potabilă la curtea ta",
];

const Dot = () => <span className="h-2 w-2 shrink-0 rounded-full bg-white/60" aria-hidden="true" />;

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center gap-6 pr-6 md:gap-10 md:pr-10">
          <span className="whitespace-nowrap font-display text-lg font-bold uppercase tracking-wide text-white md:text-2xl">
            {t}
          </span>
          <Dot />
        </span>
      ))}
    </div>
  );
}

export default function MarqueeRibbon() {
  return (
    <section aria-label="Servicii foraje" className="relative overflow-hidden bg-hydro-navy py-8">
      <div className="marquee -rotate-1 -mx-6 bg-hydro-blue py-4 shadow-[0_10px_40px_rgba(0,119,182,0.35)]">
        <div className="marquee-track">
          <Row />
          <Row hidden />
        </div>
      </div>
    </section>
  );
}
